import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import './CalendarInfoBox.css';

export default function CalendarInfoBox({ calendar, onClose }) {
    const [qrSrc, setQrSrc] = useState(null);
    const url = `${window.location.origin}/calendars/${calendar.id}.ics`;

    useEffect(() => {
        if (!calendar) return;
        QRCode.toDataURL(url, { width: 200 })
            .then(setQrSrc)
            .catch(console.error);
    }, [calendar]);

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(url);
            alert('Link kopiert!');
        } catch {
            prompt('Kopieren fehlgeschlagen, bitte manuell kopieren:', url);
        }
    };

    if (!calendar) return null;

    return (
        <div className="calendar-info-backdrop" onClick={() => onClose(null)}>
            <div className="calendar-info-box" onClick={e => e.stopPropagation()}>
                <h2>{calendar.name}</h2>


                {qrSrc && (
                    <div className="qrcode">
                        <img src={qrSrc} alt="QR Code" />
                    </div>
                )}


                <div className="qr-link">
                    <code>{url}</code>
                </div>

                <div className="qr-actions">
                    <button onClick={copyLink}>Link kopieren</button>
                    <button onClick={onClose}>Close</button>
                </div>

            </div>
        </div>
    );
}
